import React from 'react';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import { FDStack } from '@facet-wealth/design';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import {
  IncomeInformationSection,
} from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/IncomeInformation/IncomeInformationSection';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';

function IncomeInformationOnboardingLayout() {
  useScrollTopOnMount();
  const {
    resource,
    onSubmit: onSubmitMetaForm,
  } = useMetaLayoutContext();

  const { loadOnboardingStepCollection, refreshOnboardingStepCollection } = useSurveyContext();
  const clientIncomeInformation = resource.attr('clientIncomeInformation').resources().head();
  if (!clientIncomeInformation) {
    return null;
  }

  return (
    <FDStack
      direction={'column'}
      spacing={4}
      alignItems={'center'}
    >
      <PageContentTop title={resource.attr('title')} />
      <FDStack
        direction={'column'}
        spacing={2}
        alignItems={'center'}
        width={'100%'}
      >
        {resource.attr('clientIncomeInformation').resources().list().map((clientIncomeInfo) => (
          <IncomeInformationSection
            key={clientIncomeInfo.id()}
            clientIncomeInformationResource={clientIncomeInfo}
            handleAddIncomeRelationship={loadOnboardingStepCollection}
            onEditIncome={loadOnboardingStepCollection}
            onDeleteIncome={refreshOnboardingStepCollection}
          />
        ))}
      </FDStack>
      <SurveyStepFooter
        onSubmit={onSubmitMetaForm}
      />
    </FDStack>
  );
}

IncomeInformationOnboardingLayout.propTypes = {};

IncomeInformationOnboardingLayout.defaultProps = {};

export { IncomeInformationOnboardingLayout };
